import { jsx as _jsx } from "react/jsx-runtime";
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import '@styles/webdesktop/stylesheets/popover.scss';
import { forwardRef } from 'react';
import { createPortal } from 'react-dom';
import { usePopover } from './usePopover';
export const Popover = forwardRef(({ className, left, top, minWidth, maxWidth, minHeight, maxHeight, children, excludeRefs, onOutsideClick, isPinned = false }, ref) => {
    const { getPopoverStyle } = usePopover({
        ref: ref,
        excludeRefs,
        onOutsideClick,
        isPinned
    });
    const menuStyle = getPopoverStyle({
        top,
        left,
        minWidth,
        maxWidth,
        minHeight,
        maxHeight
    });
    const portalContainer = document.getElementById('popover-container');
    if (portalContainer === null) {
        return null;
    }
    const popover = (_jsx("div", { ref: ref, className: `popover ${className}`, style: menuStyle, children: children }));
    return createPortal(popover, portalContainer);
});
